import { Transformation } from 'app/model/dataflow/transformation';
import { PartitionConvertor } from './partition.convertor';
import { TransformPlainObject } from 'worker/app-workers/shared/plainObjects/transform.plainObject';
import { Metamodel } from 'app/model/base/model';
import { IResourceContext } from 'shell-models-lib';

export abstract class TransformConvertorBase {
    protected _handledConfigs: string[] = [];

    constructor(protected transformObject: TransformPlainObject, protected transformation: Transformation) {
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        this.transformation.name = this.transformObject.name;
        this.convertInputStream();
        this.convertOutputStream();
        this.convertPartition();
        return this.transformation;
    }

    public postConvert(): void {
        this.transformObject.configs.forEach((configValue, configName) => {
            if (!Metamodel.modelOf(this.transformation).hasAttribute(configName) && !this._handledConfigs.includes(configName)) {
                this.transformation.unknownProps.push(`${configName}: ${configValue}`);
            }
        });
    }

    public convertPartition(): void {
        PartitionConvertor.convertFromPlainObject(this.transformObject.partition, this.transformation);
    }

    public convertOutputStream(): void {
        this.transformObject.outputStreams.forEach((outputStream) => this.transformation.addOutputStream(outputStream.name));
    }

    public convertInputStream(): void {
        this.transformObject.inputStreams.forEach((inputStream) => this.transformation.inputStreamNames.push(inputStream.name));
    }
}
